import React from 'react'

export default class IconsDnDSubmit extends React.Component {
    render() {
        let color = '#000000'
        // if (this.props.color) color = this.props.color
        let className = 'icons-icon'
        return (
            <svg
                className={className}
                style={this.props.style}
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
            >
                <path
                    d='M9.33333 2.7334L8 4.00007'
                    stroke={color}
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M3.40001 5.33338L1.46667 4.80005'
                    stroke={color}
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M4 8L2.73334 9.33333'
                    stroke={color}
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M4.79999 1.46655L5.33332 3.39989'
                    stroke={color}
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M6.02466 6.46002C5.9988 6.39912 5.99174 6.33189 6.00436 6.26695C6.01698 6.202 6.04872 6.14231 6.0955 6.09553C6.14228 6.04875 6.20197 6.01701 6.26692 6.00439C6.33186 5.99177 6.39909 5.99883 6.45999 6.02469L13.7933 9.02469C13.8586 9.05146 13.9137 9.09825 13.9507 9.15833C13.9876 9.2184 14.0046 9.28866 13.9991 9.35899C13.9936 9.42932 13.966 9.4961 13.9201 9.54972C13.8743 9.60333 13.8126 9.64102 13.744 9.65735L10.8447 10.3514C10.725 10.3799 10.6155 10.4411 10.5285 10.5281C10.4414 10.615 10.3801 10.7244 10.3513 10.844L9.65799 13.744C9.64183 13.8129 9.60419 13.8748 9.5505 13.9209C9.49682 13.9669 9.42987 13.9947 9.35936 14.0002C9.28884 14.0057 9.2184 13.9886 9.15823 13.9514C9.09806 13.9142 9.05128 13.8589 9.02466 13.7934L6.02466 6.46002Z'
                    stroke={color}
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </svg>
        )
    }
}
